import { ComboBoxDoubleLineOption } from '../../../cdl/ComboBox/ComboBox';
import { KeyPortHighlight } from '../../../keyport/KeyPortHighlight';
import type { NoSchedulePortOption } from '../PortDetailSelect';

interface PortOptionWithoutScheduleProps {
    option: NoSchedulePortOption;
}

export const PortOptionWithoutSchedule = ({ option }: PortOptionWithoutScheduleProps) => {
    const portCountryWithLocode = `${option.port.country.name} (${option.port.locCode})`;

    return (
        <ComboBoxDoubleLineOption
            title={option.label}
            description={portCountryWithLocode}
            titleSuffix={<KeyPortHighlight portId={option.port.id} vesselId={option.vesselId} />}
        />
    );
};
